<app-bread-crumb-options></app-bread-crumb-options>
<div class="container">
    <div class="row margin-top-10-pct">
        <div class="m-auto col-md-12 col-sm-12 col-xs-12 text-center">
            <form [formGroup]="investmentForm" novalidate>
                <div class="ques-box clearfix sh-50">
                    <div class="about-row pb-3 d-md-flex d-lg-flex">
                        <div class="font-30">I am looking to invest </div>
                        <div class="font-30 investment-input amountSmallScreen">
                            <input type="text" name="investment" class="form-control border-radius-10 cursor-pointer"
                                [placeholder]="investmentPlaceholder" [(ngModel)]="investmentInfo.investment" (blur)="utilityService.formatValue($event,'currency')"
                                formControlName="investment"
                                aria-label="Investment amount"
                                data-testid="get-started.investment-info.investment-amount-input">
                            <div *ngIf="investmentFormSubmitted" class="text-danger" role="alert">
                                <div *ngIf="formControl.investment.errors?.required || formControl.investment.errors?.invalidinvestment" class="font-16 pt-1 float-start">Amount is mandatory.</div>
                            </div>
                        </div>
                        <div class="font-30"> and plan to retire at </div>
                        <div class="font-30 investment-input">
                            <select id="retirement-age" name="retirementAge" [(ngModel)]="investmentInfo.retirementAge"
                                formControlName="retirementAge" class="form-control border-radius-10 cursor-pointer"
                                aria-label="Retirement age"
                                data-testid="get-started.investment-info.retirement-age-select">
                                <option *ngFor="let retirement of retirementYearList" value="{{retirement.year}}">{{retirement.age}}</option>
                            </select>
                            <div *ngIf="investmentFormSubmitted" class="text-danger" role="alert">
                                <div *ngIf="formControl.retirementAge.errors?.required" class="font-16 pt-1">Retirement Age is mandatory.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="showAdvisorSentence">
                        <div class="about-row d-md-flex d-lg-flex">
                            <div class="font-30">I want to work with </div>
                            <div class="font-30 advisorDropDown investment-input">
                                <input type="text" placeholder="{{objModal.showAdvisorText}}"
                                    class="form-control border-radius-10 cursor-pointer"
                                    formControlName="advisor"
                                    id="typeahead-format"
                                    [(ngModel)]="investmentInfo.advisor"
                                    [ngbTypeahead]="searchAdvisor"
                                    [resultFormatter]="formatAdvisor"
                                    [inputFormatter]="formatAdvisor"
                                    (selectItem)="onAdvisorSelect($event)"
                                    autocomplete="off"
                                    [required]="showAdvisorSentence"
                                    aria-label="Search for an advisor"
                                    data-testid="get-started.investment-info.advisor-search-input">
                            </div>

                            <div class="font-30 investment-input">or</div>
                            <div class="font-30 investment-input">
                                <a class="btn btn-primary btn-sm-margin" [ngClass]="{'investment-info-disabled': urlData != ''}"
                                    (click)="updateAdvisorbtn()"
                                    data-testid="get-started.investment-info.pick-advisor-btn">{{advisorBtnLabel}}</a>
                            </div>
                            <div class="font-30 investment-input">as my advisor.</div>
                        </div>
                        <div *ngIf="investmentFormSubmitted" class="text-danger" role="alert">
                            <div *ngIf="formControl.advisor.errors?.required"  class="font-16 pt-1">You must select an advisor or click on the
                                pick one for me.</div>
                        </div>
                    </div>

                    <div *ngIf="investmentInfo.advisor && investmentInfo.advisor.url && !disableAdvisor">
                        <div class="about-row pt-5 ">
                            <div class=" align-items-start mt-3">
                                <a href="{{investmentInfo.advisor.url}}" target="_blank" class="text-primary advisor-url font-16"
                                    data-testid="get-started.investment-info.advisor-adv-link">
                                    {{investmentInfo.advisor.fullname}} - ADV Part 2B
                                </a>
                                <br>
                                <div class="d-inline-block pt-2">
                                    <input type="checkbox"
                                        class="mt-1 me-2 styled-checkbox"
                                        formControlName="acknowledgment"
                                        [(ngModel)]="acknowledgment"
                                        id="styled-checkbox-1"
                                        data-testid="get-started.investment-info.adv-acknowledgment-checkbox">
                                <label for="styled-checkbox-1" class="font-16">
                                    I acknowledge that I have received the ADV Part 2B for the selected advisor.
                                    </label>
                                </div>
                            </div>
                            <div *ngIf="investmentFormSubmitted" class="text-danger" role="alert">
                                <div *ngIf="formControl.acknowledgment.errors?.required" class="font-14 pt-1">Please acknowledge that you have received the ADV Part 2B.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div>
                <app-buttonbar (clickedprev)="gotoPreviousState()" (clickednext)="submitInvestment()"></app-buttonbar>
            </div>
        </div>
    </div>
</div>
